module.exports = __webpack_public_path__ + "img/pr-7.8790613c.png";